const translations = {
  page_title: 'Activity log',

  // Filters
  select_user: 'Select User',
  select_action: 'Select Action',
  search_placeholder: 'Search by user, action, or detail',
  this_month: 'This Month',
  last_month: 'Last Month',
  custom: 'Custom',
  additional_filters: 'Additional Filters',

  // Table columns
  date: 'Date',
  user: 'User',
  action: 'Action',
  source: 'Source',
  detail: 'Detail',

  // Action types
  action_created: 'Created',
  action_updated: 'Updated',
  action_deleted: 'Deleted',
  action_exported: 'Exported',
  action_modified: 'Modified',

  // Sort options
  date_desc: 'Date (Newest First)',
  date_asc: 'Date (Oldest First)',
  name_asc: 'Name (A-Z)',
  name_desc: 'Name (Z-A)',
  action_asc: 'Action (A-Z)',
  action_desc: 'Action (Z-A)',
  sort_custom: 'Sort',

  // Results
  log_found_1: '1 log found',
  logs_found_n: '{{n}} logs found',
  no_logs: 'No activity logs found',
  no_logs_search: 'No logs found matching your search',
  no_activity_description: 'There are no activity logs in the selected period.',

  view_more: 'View more',
  view_less: 'View less',
};

export default translations;
